import React from "react";

const getPossibleScore = (gameName, score) => {
  let defaultMax = 100;
  const name = gameName?.toLowerCase() || "";
  
  if (name.includes("ping pong") || name.includes("pingpong")) {
    // 5-min game, user gains points on hits. Average user achieves around 50-80 hits.
    defaultMax = 80;
  } else if (name.includes("shooter")) {
    // Spawns 1 enemy every 1.5s. In 300s, max spawned is 200. Realistic high score is around 150.
    defaultMax = 150;
  } else if (name.includes("rain drop") || name.includes("raindrop")) {
    // Spawns 1 drop every 2s. In 300s, max spawned is 150. Realistic high score is around 120.
    defaultMax = 120;
  } else if (name.includes("obstacle") || name.includes("jump")) {
    // Spawns 1 obstacle every 1.5s. Max is 200. Realistic high score is around 120.
    defaultMax = 120;
  } else if (name.includes("match gabor") || name.includes("matchgabor")) {
    // 10-min game (600s), approx 1 match per 4s = 150 matches. At 3 points/match, score is ~450.
    defaultMax = 450;
  } else if (name.includes("color trap") || name.includes("colortrap")) {
    // Moving target requires precise clicks. User tracks & clicks about 1 every 3-4s.
    defaultMax = 80;
  } else if (name.includes("rock chart") || name.includes("rockchart")) {
    // Letters sequential typing. Speed is about 1.5s per letter.
    defaultMax = 200;
  } else if (name.includes("search") || name.includes("quest")) {
    // Finding 1 correct character in a grid of 48 takes about 4-5s.
    defaultMax = 60;
  } else if (name.includes("smooth")) {
    // Tracking and keypress typing. Speed is about 1.5-2s per letter.
    defaultMax = 150;
  } else if (name.includes("rapid")) {
    // Reacting to letters appearing in random areas. Speed is about 1.2-1.5s per letter.
    defaultMax = 180;
  }
  
  return Math.max(defaultMax, score || 0);
};

const UserDashboardDataTable = ({ game }) => {
  const possibleScore = game?.possibleScore || getPossibleScore(game?.gameName, game?.score);
  const percent = possibleScore 
    ? Math.ceil((game.score / possibleScore) * 100) 
    : 0;

  return (
    <tr className="hover:bg-slate-50/50 transition duration-150">
      <td className="px-6 py-4 font-bold text-slate-800 text-sm">
        {game?.gameName}
      </td>
      <td className="px-6 py-4 text-xs font-semibold text-slate-400 whitespace-nowrap">
        {game?.date} at {game?.time || "N/A"}
      </td>
      <td className="px-6 py-4 text-sm font-extrabold text-secondary text-right">
        {percent}%
      </td>
    </tr>
  );
};

export default UserDashboardDataTable;
